export default {
  'inventories.warehouse': 'Warehouse',
};
